import request from '@/utils/request'

let AssembleApi = {


  /*拼团活动列表*/
  activeList(data) {
    return request._post('/shop/plus.assemble.active/index', data);
  },
  /*添加拼团活动*/
  addActive(data) {
    return request._post('/shop/plus.assemble.active/add', data);
  },
  /*获取拼团活动数据*/
  editActive(data) {
    return request._get('/shop/plus.assemble.active/edit', data);
  },
  /*保存拼团活动*/
  saveActive(data) {
    return request._post('/shop/plus.assemble.active/edit', data);
  },
  /*删除拼团活动*/
  delActive(data) {
    return request._post('/shop/plus.assemble.active/delete', data);
  },
  /*发布消息*/
  sendMsg(data) {
      return request._post('/shop/plus.assemble.active/sendMsg', data);
  },
  /*获取活动已选商品*/
  selectProduct(data) {
    return request._post('/shop/plus.assemble.product/selectProduct', data);
  },
  /*拼团商品详情*/
  detail(data) {
    return request._post('/shop/plus.assemble.product/detail', data);
  },
  /*保存拼团商品*/
  saveData(data) {
    return request._post('/shop/plus.assemble.product/saveData', data);
  },
  delProduct(data) {
    return request._post('/shop/plus.assemble.product/delete', data);
  },

  /*保存设置*/
  saveSetting(data) {
    return request._post('/shop/plus.assemble.setting/index', data);
  },
  /*获取设置*/
  getSetting(data) {
    return request._get('/shop/plus.assemble.setting/index', data);
  },

}
export default AssembleApi;



// WEBPACK FOOTER //
// ./src/api/assemble.js